<template>
  <div class="white" style="min-height:550px;">
    <v-toolbar flat color="white" style="height:45px;">
      <v-toolbar-title class="pb-3">Relatórios</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-tabs v-model="active" color="white" slider-color="primary" class="pt-2 px-3 bigListTabs">
      <v-tab
        v-for="tab in tabs"
        show-arrows
        :replace="true"
        :key="tab.id"
        :value="tab.id"
        class="grey--text text--darken-1"
      >{{tab.name}}</v-tab>

      <v-tab-item>
        <v-card flat>
          <ExpensesGroupsReport :condominiumsList="condominiumsList" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <docReportFilters
          v-show="active == 1"
          :filterReport="getContractStatus"
          :changeTitle="changeTitle"
        />
        <v-layout row wrap v-if="typeDocs.length">
          <v-flex xs2 pt-3 pb-2>
            <DashboardPdf v-if="typeDocs.length" />
          </v-flex>

          <v-flex xs2 pt-3 pb-2 mt-1>
            <!-- <ListPdf v-if="typeDocs.length" /> -->
            <v-btn
              small
              color="blue darken-1"
              class="white--text pr-3 mt-2"
              @click="generateReport"
            >
              <v-icon class="mr-2" style="font-size:20px;" left dark>print</v-icon>Planilhas detalhadas
            </v-btn>
          </v-flex>
        </v-layout>

        <p
          v-if="!typeDocs.length"
          style="width:100%"
          class="title text-xs-center pt-5"
        >Selecione um condomínio para geração dos relórios.</p>
        <v-layout row wrap v-if="typeDocs.length">
          <v-flex xs6 pt-3 pb-2>
            <h2 class="body-2 text-xs-left pl-3">
              <b>{{condominiumName}}</b>
            </h2>
          </v-flex>
          <v-flex xs6 row pt-3 pr-4 layout pb-2>
            <v-spacer></v-spacer>
            <div class="statusRounded ml-2 mr-1 mt-1" style="background:#4caf50;"></div>
            <span class="mr-3">Vigentes</span>
            <div class="statusRounded ml-2 mr-1 mt-1" style="background:#ffab00;"></div>
            <span class="mr-3">A vencer</span>
            <div class="statusRounded ml-2 mr-1 mt-1" style="background:#c62828;"></div>
            <span class="mr-3">Vencidos</span>
            <div class="statusRounded ml-2 mr-1 mt-1" style="background:#696A6D;"></div>
            <span class="mr-3">Em obtenção</span>
          </v-flex>
        </v-layout>

        <v-layout row wrap white pb-4 v-if="typeDocs.length">
          <v-flex xs12 md4 sm6 mt-3 mb-3 v-for="(typeDoc, i) in typeDocs" :key="i">
            <DocumentsCharts
              :type_id="typeDoc['type_id']"
              :docName="typeDoc['type_name']"
              :series="typeDoc['statuses']"
              :expiredsDocs="typeDoc['expiredList']"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <SyndicationMandateReport :condominiumsList="condominiumsList" />
      </v-tab-item>
    </v-tabs>
    <DocDetailsDialog :condominiunSel="condominiumName" />
  </div>
</template>

<script>
import SyndicationMandateReport from '@/components/reports/SyndicationMandate/SyndicationMandate'
// import ListPdf from './documentReports/ListPdf'
import DashboardPdf from '@/components/reports/documentReports/DashboardPdf'
import ExpensesGroupsReport from '@/components/reports/ExpensesGroupsReport'
import docReportFilters from '@/components/reports/documentReports/DocReportFilters'
import DocumentsCharts from '@/components/reports/documentReports/DocumentsCharts'
import DocDetailsDialog from '@/components/reports/documentReports/DocDetailsDialog'

export default {
  name: 'Reports',

  components: {
    SyndicationMandateReport,
    docReportFilters,
    ExpensesGroupsReport,
    DocumentsCharts,
    DocDetailsDialog,
    DashboardPdf
    // ListPdf
  },

  data () {
    return {
      condominiumsList: [],
      docDetailDialogShow: false,
      typeDocs: [],
      condominiumName: '',
      condominiumId: null,
      date: '',
      active: 0,
      tabs: [
        { id: '0', name: 'Grupo de despesas' },
        {
          id: 2,
          name: 'Documentos e contratos'
        },
        {
          id: 3,
          name: 'Mandatos de síndico'
        }
      ]
    }
  },

  mounted () {
    this.getComdominiums()
  },

  methods: {
    getComdominiums () {
      this.financial_id = ''
      this.account_id = ''
      let obj = {
        url: '/api/condominium',
        query: '',
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.condominiumsList = response.data
      })
    },

    generateReport () {
      // window.open(
      //   'http://vps36617.publiccloud.com.br/api/pdf/reports_document',
      //   '_blank'
      // )
      // let dataSearch = {}

      // dataSearch.params = {
      //   condominium_id: this.condominiumId,
      //   date: this.date
      // }

      // let obj = {
      //   url: '/api/pdf/reports_document',
      //   query: dataSearch,
      //   method: 'get'
      // }
      // this.$store.dispatch('request/doRequest', obj).then(response => {
      //   // //console.log(response.data)
      //   // this.allStatus = response.data[0];
      // })

      let query = {
        condominium_id: this.condominiumId,
        date: this.date
      }

      let obj = {
        url: 'api/report_documents',
        query: query,
        method: 'post',
        filename: 'report.pdf'
      }

      this.$store.dispatch('request/doRequest', obj).then(response => {
        console.log('DOWNLOAD SUCCESS')
        window.open(`${response.data.file}`)
      })
    },

    getContractStatus (data, cbo) {
      this.condominiumId = data.condominium_id
      this.date = data.date_end

      this.typeDocs = []

      if (!data.condominium_id) {
        cbo.focus()
        return
      }

      let obj = {
        url: '/api/reports_docs',
        query: data,
        method: 'post'
      }
      // this.$store.state.docsReports.condominiumId = data.condominium_id;
      this.$store.commit('docsReports/updateSearchData', {
        id: data.condominium_id,
        date_init: data.date_init,
        date_end: data.date_end
      })
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        // this.typeDocs = [...this.jsonDocs];
        let charts = response.data.filter((type) => {
          if (type.statuses[0] || type.statuses[1] || type.statuses[2] || type.statuses[3]) {
            return type
          }
        })
        let categories = charts.map((ctg) => {
          let obj = {}
          obj.type_id = ctg.type_id
          obj.type_name = ctg.type_name
          return obj
        })
        this.$store.commit('docsReports/updateCboTypeDocs', categories)
        this.typeDocs = [...charts]
      })
    },

    changeTitle (txt) {
      this.condominiumName = txt
    }
  }
}
</script>

<style>
.statusRounded {
  height: 12px;
  border-radius: 50px;
  width: 12px;
  /* margin-top: 1px; */
}
.detailsDocs {
  margin-top: 35px;
}
</style>
